import { fetchOutgoingInvitationsCount } from "app/actions/invitation";
import { useActions, useSelector } from "app/utils/hooks";
import { useEffect, useState } from "react";
import { shallowEqual } from "react-redux";
import { RootState } from "typedefs";

export const ActivityInvitationsModel = () => {
  const invitationAction = useActions({
    fetchOutgoingInvitationsCount,
  });

  const [outgoingCount, setOutgoingCount] = useState(0);
  const [activeTab, setActiveTab] = useState<"incoming" | "outgoing">(
    "incoming",
  );

  const invitations = useSelector(
    (state: RootState) => state.notification?.totalUnseen?.invitations ?? 0,
    shallowEqual,
  );

  const handleTabChange = (tab: "incoming" | "outgoing") => {
    setActiveTab(tab);
  };

  useEffect(() => {
    invitationAction
      .fetchOutgoingInvitationsCount({ direction: "outgoing" })
      .then((res: number) => setOutgoingCount(res));
  }, [invitationAction]);

  return {
    activeTab,
    handleTabChange,
    invitations,
    outgoingCount,
  };
};
